import styled from 'styled-components';
import { colors } from 'styles/colors';
import React, { FC } from 'react';
import { Text } from 'components/text/Text';

const SingleStatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 171px;
  max-width: 169px;
  text-align: center;
`;

const IconWrapper = styled.div`
  background-color: ${colors.lightTeal};
  border-radius: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  width: 56px;
  margin-bottom: 16px;
`;

type SingleStatisticProps = {
  img: any;
  value: string;
  caption: string;
};

export const SingleStatistic: FC<SingleStatisticProps> = ({ img, caption, value }) => {
  return (
    <SingleStatWrapper>
      <IconWrapper>
        <img
          color={colors.grayText}
          height={34}
          width={34}
          src={img}
          alt={caption}
          loading="lazy"
        />
      </IconWrapper>
      <Text size={30} fontWeight={500} color={'blueGray'}>
        {value}
      </Text>
      <Text size={18} color={'blueGray'}>
        {caption}
      </Text>
    </SingleStatWrapper>
  );
};
